<template>
  <div
    :class="[
      'sj-dialog',
      {
        'sj-dialog--draggable': draggable
      }
    ]"
    :style="
      Object.assign(
        { width: width, height: height, maxWidth },
        dialogPositionStyle
      )
    "
  >
    <i
      v-if="showClose"
      class="icon_com commulti_close sj-dialog-close"
      :class="`sj-dialog-close-${closePosition}`"
      @click="$emit('close')"
    >
    </i>
    <div class="sj-dialog-header" v-if="showHeader">
      <span class="sj-dialog-title">{{ title }}</span>
      <slot name="header"></slot>
    </div>
    <div class="sj-dialog-body">
      <slot></slot>
    </div>
    <div class="sj-dialog-footer" v-if="showFooter">
      <slot name="footer">
        <div class="sj-dialog-footer-button" @click="$emit('close')">取消</div>
        <div class="sj-dialog-footer-button" @click="$emit('confirm')">
          确定
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SjDialogInner",
  props: {
    title: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    closePosition: {
      type: String,
      default: "top",
      validator(v) {
        return ["top", "right"].indexOf(v) !== -1;
      }
    },
    draggable: {
      type: Boolean,
      default: false
    },
    dragSelector: {
      type: String,
      default: ".sj-dialog-header"
    }
  },
  data() {
    return {
      dialogPosition: null,
      dragStartPosition: null,
      dragNowPosition: null
    };
  },
  computed: {
    dialogPositionStyle() {
      const {
        draggable,
        dialogPosition,
        dragStartPosition,
        dragNowPosition
      } = this;
      if (!draggable || !dialogPosition) {
        return null;
      }
      let { x, y } = dialogPosition;
      if (dragNowPosition && dragStartPosition) {
        x += dragNowPosition.x - dragStartPosition.x;
        y += dragNowPosition.y - dragStartPosition.y;
      }
      return {
        left: `${x}px`,
        top: `${y}px`,
        transform: "none"
      };
    }
  },
  mounted() {
    if (this.draggable) {
      this.initDrag();
    }
  },
  methods: {
    /**
     * initDrag - 初始化拖拽
     */
    initDrag() {
      if (!this.$el) return;
      const { dragSelector } = this;
      const dom = this.$el.querySelector(dragSelector);
      if (!dom) return;
      if (!dom.classList.contains("sj-dialog-draggable")) {
        dom.classList.add("sj-dialog-draggable");
      }
      dom.addEventListener("mousedown", this.dragMousedown);
    },
    /**
     * initDrag - 清除拖拽
     */
    clearDrag() {
      this.clearDragPosition();
      if (!this.$el) return;
      const { dragSelector } = this;
      const dom = this.$el.querySelector(dragSelector);
      if (!dom) return;
      if (dom.classList.contains("sj-dialog-draggable")) {
        dom.classList.remove("sj-dialog-draggable");
      }
      dom.removeEventListener("mousedown", this.dragMousedown);
    },
    clearDragPosition() {
      this.dialogPosition = null;
      this.dragStartPosition = null;
      this.dragNowPosition = null;
    },
    /**
     * dragMousedown - 拖拽Mousedown回调
     */
    dragMousedown(e) {
      const dialogDom = this.$el;
      if (!dialogDom) return;
      const dialogDomClientRect = dialogDom.getBoundingClientRect();
      this.dialogPosition = {
        x: dialogDomClientRect.left,
        y: dialogDomClientRect.top
      };
      this.dragStartPosition = {
        x: e.clientX,
        y: e.clientY
      };
      this.dragNowPosition = null;
      document.addEventListener("mousemove", this.dragMousemove);
      document.addEventListener("mouseup", this.dragMouseup);
    },
    /**
     * dragMousedown - 拖拽Mousemove回调
     */
    dragMousemove(e) {
      this.dragNowPosition = {
        x: e.clientX,
        y: e.clientY
      };
    },
    /**
     * dragMousedown - 拖拽Mouseup回调
     */
    dragMouseup() {
      const { dialogPosition, dragStartPosition, dragNowPosition } = this;
      if (dialogPosition && dragStartPosition && dragNowPosition) {
        this.dialogPosition = {
          x: dialogPosition.x + dragNowPosition.x - dragStartPosition.x,
          y: dialogPosition.y + dragNowPosition.y - dragStartPosition.y
        };
      }
      this.dragStartPosition = null;
      this.dragNowPosition = null;
      document.removeEventListener("mousemove", this.dragMousemove);
      document.removeEventListener("mouseup", this.dragMouseup);
    }
  },
  watch: {
    draggable(val) {
      if (val) {
        this.initDrag();
      } else {
        this.clearDrag();
      }
    }
  }
};
</script>

<style lang="less">
@dialog-background-color: @color-antibg;
@dialog-box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
@dialog-border-radius: @base-border-radius;
@dialog-border: @base-border-width @base-border-style @color-gray-3;
@dialog-padding: 20px;

@dialog-header-padding: 40px;

@dialog-close-font-size: 15px;
@dialog-close-color: @color-antibg;
@dialog-close-top: 15px;

.sj-dialog {
  position: relative;
  background-color: @dialog-background-color;
  border-radius: @dialog-border-radius;
  box-shadow: @dialog-box-shadow;
  //border: @dialog-border;
  box-sizing: border-box;
  width: 50%;

  &.sj-dialog--draggable {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  .sj-dialog-draggable {
    cursor: move;
  }

  .sj-dialog-close {
    position: absolute;
    cursor: pointer;
    color: white;
    font-size: @dialog-close-font-size;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;

    &.sj-dialog-close-top {
      top: -(@dialog-close-top+ @dialog-close-font-size);
      right: 0;
    }
    &.sj-dialog-close-right {
      top: @dialog-close-top;
      right: -(@dialog-close-top+ @dialog-close-font-size);
    }
    &.sj-dialog-close-top:hover,
    &.sj-dialog-close-right:hover {
      background: @color-gray-2;
      color: @color-normal;
    }
  }

  .sj-dialog-header {
    padding: @dialog-padding @dialog-padding @dialog-padding / 2 @dialog-padding;

    .sj-dialog-title {
      .text("h3", "dark", "semibold");
    }
  }

  .sj-dialog-body {
    // .text("body", "light");
    //padding: @dialog-padding / 2 @dialog-padding;
  }

  .sj-dialog-footer {
    height: 50px;
    box-sizing: border-box;
    border-top: @dialog-border;
    display: flex;

    .sj-dialog-footer-button {
      .text("body", "available");
      cursor: pointer;
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .sj-dialog-footer-button:hover,
    .sj-dialog-footer-button:active {
      background-color: @color-gray-3;
    }
    .sj-dialog-footer-button:nth-child(2) {
      border-left: @dialog-border;
    }
  }
}
</style>
